<template>
    <a-drawer
      :width='width'
      :visible="visible"
      @close="onClose"
    >   
        <template #title>
            <div class="flex_div">
                <img :src="typicalTitle" alt="" srcset="" class="icon" />
                <span class="title">案例详情</span>
            </div>
        </template>

        <div class="typical-cases-title">{{ details['标题'] || '-' }}</div>
        <div class="typical-cases-tip">提供单位：{{ details['提供单位'] || '-' }}</div>
        <div class="typical-cases-tip">提供时间：{{ details['提供时间'] || '-' }}</div>
        <div class="typical-cases-tip">案例编号：{{ details['案例编号'] || '-' }}</div>

        <div class="flex_div mt-30">
            <img :src="Introduction" alt="" srcset="" class="icon" />
            <span class="title">案情简介</span>
        </div>
        <div class="text">{{ details['案情简介'] || '-' }}</div>

        <div class="flex_div mt-30">
            <img :src="process" alt="" srcset="" class="icon" />
            <span class="title">处理过程及结果</span>
        </div>
        <div class="text">{{ details['处理过程及结果'] || '-' }}</div>

        <div class="flex_div mt-30">
            <img :src="parse" alt="" srcset="" class="icon" />
            <span class="title">案例评析</span>
        </div>
        <div class="text">{{ details['案例评析'] || '-' }}</div>

    </a-drawer>

</template>

<script>
import typicalTitle from '@/assets/typical-title.png'
import Introduction from '@/assets/Introduction.png'
import process from '@/assets/process.png'
import parse from '@/assets/parse.png'
export default {
    props:{
        visible:{
            type: Boolean,
            default: false
        },
      details:{
          type:Object,
        default:{}
      }
    },
  watch:{
    visible(val){
      if(val){
        if(window.innerWidth < 720){
          this.width = '100%'
        }else{
          this.width = 610
        }
      }
    }
  },
    data() {
        return {
            typicalTitle,
            Introduction,
            process,
            parse,
          width:610
        }
    },
  methods: {
        onClose() {
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.mt-30{
    margin-top: 30px;
}
.text{
    font-size: 14px;
    color: #2C2C2C;
    line-height: 28px;
    word-break: break-all;
}
.typical-cases-title{
    font-weight: bold;
    font-size: 16px;
    color: #2C2C2C;
    word-break: break-all;
    margin-bottom: 12px;
}
.typical-cases-tip{
    font-size: 14px;
    color: #999999;
    line-height: 22px;
    margin-bottom: 4px;    
}
.title{
    font-weight: bold;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
}
.flex_div{
    display: flex;
    align-items: center;
}
.icon{
    width: 16px;
    height: 16px;
    margin-right: 7px;
}
</style>